import { combineEpics } from "redux-observable";
import { loadResourcesUtils } from "@ane/core/lib/utils";
import DataplaneResource from "../../../resources/DataplaneResources.js";
const prefix = "ANALYSIS_CONFIG_LIST";
const analysisRulesPrefix = `${prefix}/ANALYSIS_RULES`;
const deleteAnalysisRulesPrefix = `${prefix}/DELETE_ANALYSIS_RULES`;
const loadAnalysisRulesEpicReducerInputArg = {
  actionPrefix: analysisRulesPrefix,
  reduxKeyNested: () => ["analysisRules"],
  loadResource: (workspaceId) => DataplaneResource.getAnalysisRules(workspaceId),
  onCompleteSuccess: (result) => result
};
const loadAnalysisRulesEpicReducer = loadResourcesUtils(loadAnalysisRulesEpicReducerInputArg);
const deleteAnalysisRulesEpicReducerInputArg = {
  actionPrefix: deleteAnalysisRulesPrefix,
  reduxKeyNested: () => ["deleteAnalysisRules"],
  loadResource: (inputPayload) => DataplaneResource.deleteAnalysisRules(inputPayload.workspaceId, inputPayload.analysisRuleNames),
  onCompleteSuccess: (result) => {
    window.location.reload();
    return result;
  }
};
const deleteAnalysisRulesEpicReducer = loadResourcesUtils(deleteAnalysisRulesEpicReducerInputArg);
const List_epics = combineEpics(loadAnalysisRulesEpicReducer.epic, deleteAnalysisRulesEpicReducer.epic);
export {
  analysisRulesPrefix,
  List_epics as default,
  deleteAnalysisRulesEpicReducer,
  deleteAnalysisRulesPrefix,
  loadAnalysisRulesEpicReducer,
  prefix
};
//# sourceMappingURL=List.epics.js.map
